<template>
  <span
    class="m-checkbox mr-8 mt-2 fb fb-cross-center"
    :disabled="disabled"
    @click="handlerClick"
  >
    <i v-show="!isChecked" class="iconfont c-171A1D-40 font-48">&#xe66f;</i>
    <i v-show="isChecked" class="iconfont c-006AFE font-48">&#xe66e;</i>
    <slot></slot>
  </span>
</template>

<script>
/* eslint-disable */
export default {
  name: 'commonCheckbox',
  components: {},
  props: {
    isChecked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handlerClick(e) {
      if (this.disabled) {
        return
      }
      this.$emit('click', e)
    }
  }
}
</script>

<style lang="scss" scoped>
.m-checkbox[disabled='disabled'] {
  opacity: 0.5;
}
</style>
